
import { useState } from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { EmployeeForm } from '../EmployeeForm';

export const FirstEmployeeSetup = () => {
  const [showForm, setShowForm] = useState(false);
  
  if (showForm) {
    return (
      <div className="space-y-6">
        <h2 className="text-2xl font-bold">Create First Employee Profile</h2>
        <EmployeeForm 
          isFirstUser={true}
          onComplete={() => window.location.reload()}
        />
      </div>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Welcome to the Employee Portal</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="mb-6">
          It looks like you haven't set up any employee profiles yet. As the first user,
          you'll need to create an admin profile to get started.
        </p>
        <Button onClick={() => setShowForm(true)}>
          Create Admin Profile
        </Button>
      </CardContent>
    </Card>
  );
};
